import { render, staticRenderFns } from "./FormBuilderItems.vue?vue&type=template&id=a350a844&scoped=true"
import script from "./FormBuilderItems.vue?vue&type=script&lang=js"
export * from "./FormBuilderItems.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderItems.vue?vue&type=style&index=0&id=a350a844&prod&lang=css"
import style1 from "./FormBuilderItems.vue?vue&type=style&index=1&id=a350a844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a350a844",
  null
  
)

export default component.exports